import React from 'react';

function DashboardHeader({ setIsSidebarOpen }) {
  return (
    <header className="sticky top-0 z-10 flex items-center justify-between whitespace-nowrap border-b border-solid border-border-color bg-page-bg/95 px-4 sm:px-8 py-3">
      
      {/* Hamburger button - only visible on mobile (md:hidden) */}
      <button 
        onClick={() => setIsSidebarOpen(true)}
        className="text-text-color md:hidden"
      >
        <span className="material-symbols-outlined">menu</span>
      </button>

      <h2 className="text-lg font-bold leading-tight tracking-[-0.015em] text-text-color">
        Department of Mines and Geology
      </h2>
      
      {/* This empty div will keep the title centered on mobile */}
      <div className="md:hidden"></div>
    </header>
  );
}

export default DashboardHeader;
